import React, { useState, useEffect, useContext } from "react";
import { store } from '../../context/store';
import { useHistory } from 'react-router-dom';

import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import DashboardSelector from "../../components/DashboardSelector";
import AssetConditionMatrixGrid from "./components/AssetConditionMatrixGrid";
import AssetDetailDrawerContent from "./components/AssetDetailDrawerContent";
import AmChartPie from "../../components/AmChartPie";
import AssetPopOutContent from "./components/AssetPopOutContent";

import { functions } from "../../constants/common-functions";

export default function AssetDetailPopOut({assetOpen, setAssetOpen, id}) {

    const globalState = useContext(store);
    const { dispatch } = globalState;
    const history = useHistory();
	
	const [blackOpen, setBlackOpen] = useState(false);
	const [whiteOpen, setWhiteOpen] = useState(false);
	
	function openDrawer() {
	    setBlackOpen(true);

	    setTimeout(function () {
	        setWhiteOpen(true);
	    }, 140);
	};
	
	function closeDrawer() {
	    setWhiteOpen(false);

	    setTimeout(function () {
	        setBlackOpen(false);
	    }, 140);
	};
	
	
	useEffect(() => {
		if(assetOpen === true){
			openDrawer();
		}
		else{
			closeDrawer();
		}
	}, [assetOpen]);

    const thisContainer = {
        display: "flex",
        position: "fixed",
        flexDirection: "column",
        //width: "100%",
        minHeight: "100vh",
        left: 60,
        top: 0
    };


    const drawer = {
        position: "fixed",
        top: "90px",
        right: -0,
        bottom: 30,
        width: "380px",
        display: "flex",
        flexDirection: "column",
        padding: "24px 20px",
        background: "linear-gradient(180deg, #0b0b0d 0%, #15161a 100%)",
        boxShadow: "-12px 0 30px rgba(0,0,0,0.45)",
        color: "#fff",
        borderTopLeftRadius: "17px",
        borderBottomLeftRadius: "17px",
		zIndex:2
    };
	

	const assetIdentity = {
	    marginBottom: "14px"
	};

	const assetCodeDark = {
	    fontSize: "12px",
	    fontWeight: 700,
	    letterSpacing: "0.6px",
	    color: "#aaa",
	    marginBottom: "4px"
	};

	const assetNameDark = {
	    fontSize: "18px",
	    fontWeight: 700,
	    color: "#fff"
	};
	
	
	const specTableDark = {
	    display: "flex",
	    flexDirection: "column",
	    gap: "8px",
	    marginTop: "12px"
	};

	const specRowDark = {
	    display: "flex",
	    alignItems: "center",
	    padding: "12px 14px",
	    borderRadius: "10px",
	    background: "linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))",
	    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.06)",
	    fontSize: "13px"
	};

	const specLabelDark = {
	    width: "130px",
	    color: "#9fa3aa",
	    fontWeight: 600,
	    letterSpacing: "0.3px",
	    textTransform: "uppercase",
	    fontSize: "11px"
	};

	const specValueDark = {
	    flex: 1,
	    color: "#ffffff",
	    fontWeight: 600
	};
	
	
	const assetPhotoPanel = {
	    height: "200px",
	    borderRadius: "14px",
	    overflow: "hidden",
	    marginBottom: "18px",
	    background: "#000",
	    boxShadow: "0 10px 26px rgba(0,0,0,0.55)"
	};

	const assetPhoto = {
	    width: "100%",
	    height: "100%",
	    objectFit: "cover"
	};
	
	
	const joinedPill = {
		    display: "flex",
		    alignItems: "center",
		    overflow: "hidden",
		    borderRadius: "16px",
		    boxShadow: "0 2px 6px rgba(0,0,0,0.18)"
		};
		
		
		function getConditionSegment(condition) {
		    var base = {
		        minWidth: "90px",
		        height: "20px",
		        display: "flex",
		        alignItems: "center",
		        justifyContent: "center",
		        fontSize: "12px",
		        fontWeight: 600,
		        color: "#fff",
		        borderTopLeftRadius: "16px",
		        borderBottomLeftRadius: "16px"
		    };

		    if (condition === "Good") {
		        base.background = "linear-gradient(180deg, #1db954, #08933a)";
		    } else if (condition === "Fair") {
		        base.background = "linear-gradient(180deg, #f5a623, #d08602)";
		    } else {
		        base.background = "linear-gradient(180deg, #d64545, #c82222)";
		    }

		    return base;
		}
		
		
		
		function getCriticalitySegment(level) {
		    var base = {
		        minWidth: "90px",
		        height: "20px",
		        display: "flex",
		        alignItems: "center",
		        justifyContent: "center",
		        fontSize: "12px",
		        fontWeight: 600,
		        color: "#fff",
		        borderTopRightRadius: "16px",
		        borderBottomRightRadius: "16px"
		    };

		    if (level === "High") {
		        base.background = "linear-gradient(180deg, #c0392b, #992216)";
		    } else if (level === "Medium") {
		        base.background = "linear-gradient(180deg, #f39c12, #c67900)";
		    } else {
		        base.background = "linear-gradient(180deg, #7f8c8d, #606b6c)";
		    }

		    return base;
		}
		
		
		function SpecRowDark({ label, value }) {
		    return (
		        <div style={specRowDark}>
		            <div style={specLabelDark}>{label}</div>
		            <div style={specValueDark}>{value}</div>
		        </div>
		    );
		}
		
		
		const blackDrawerStyle = {
		    position: "fixed",
		    top: "90px",
		    right:blackOpen ? "0px" : "-320px",
		    bottom: "30px",
		    width:"320px", 
		    overflow: "hidden",
		    transition: "right 0.45s cubic-bezier(0.22, 0.61, 0.36, 1)",
		    background: "linear-gradient(180deg, #0b0b0d 0%, #15161a 100%)",
		    boxShadow: blackOpen ? "-12px 0 30px rgba(0,0,0,0.45)" : "none",
		    borderTopLeftRadius: "18px",
		    borderBottomLeftRadius: "18px",
		    zIndex: 3,
			padding:blackOpen ? "20px" : "0px",
		};
		
		
		
		const whiteDrawerStyle = {
		    position: "fixed",
		    top: "90px",
		    bottom: "30px",
		    width: "calc(100% - 420px)",
		    left: whiteOpen ? "80px" : "100%",
		    transition: "left 0.55s cubic-bezier(0.22, 0.61, 0.36, 1)",
		    background: "#fff",
		    boxShadow: "-24px 0 48px rgba(0,0,0,0.22)",
		    borderTopLeftRadius: "22px",
		    borderBottomLeftRadius: "22px",
		    zIndex: 2,
		    overflowY: "auto"
		};

    /* =========================
       RENDER
    ========================== */

    return (
        <div style={thisContainer}>
            
				
				

				{/* WHITE DETAIL DRAWER */}
				<div
				    style={whiteDrawerStyle}
				>
					<AssetPopOutContent/>
				</div>

				{/* RIGHT DRAWER */}
				<div style={blackDrawerStyle}>
				
				<div
				    style={{
				        position: "absolute",
				        top: "4px",
				        right: "4px",
				        width: "28px",
				        height: "28px",
				        borderRadius: "50%",
				        display: "flex",
				        alignItems: "center",
				        justifyContent: "center",
				        cursor: "pointer",
				        color: "#fff",
				        fontSize: "16px",
				        background: "rgba(255,255,255,0.08)",
				        transition: "background 0.2s ease"
				    }}
				    onClick={() => {setAssetOpen(false);}}
				>
				    ✕
				</div>
					{/* ASSET PHOTO */}
					<div style={assetPhotoPanel}>
					    <img
					        src="/assetimages/lighting_panel.jpg"
					        alt="Asset"
					        style={assetPhoto}
					    />
					</div>

					{/* ASSET ID */}
					<div style={assetIdentity}>
					    <div style={assetCodeDark}>AHU-102</div>
					    <div style={assetNameDark}>Lighting Control Panel</div>
					</div>

					{/* CONDITION / CRITICALITY */}
					<div style={{ marginBottom: "18px" }}>
					    <div style={joinedPill}>
					        <div style={getConditionSegment("Fair")}>Fair</div>
					        <div style={getCriticalitySegment("High")}>High</div>
					    </div>
					</div>

					{/* SPEC TABLE */}
					<div style={specTableDark}>
					    <SpecRowDark label="Asset Class" value="Electrical / Lighting" />
					    <SpecRowDark label="Manufacturer" value="Schneider Electric" />
					    <SpecRowDark label="Model" value="PowerLogic X80" />
					    <SpecRowDark label="Serial" value="SN-A8X-22991" />
					    <SpecRowDark label="Last Serviced" value="12 Feb 2026" />
					    <SpecRowDark label="Location" value="Level 3 · East Wing" />
					</div>
				    </div>
			
			
        </div>
    );
}